import { Dispatch } from 'react';
import ETypes from '../types';

type DispatchType = {
  type: ETypes;
  payload: {
    id: string;
  };
};

export default {
  [ETypes.GET_SNIPPET]: (dispatch: Dispatch<DispatchType>) => (id: string) => {
    dispatch({
      type: ETypes.SET_NEW_SNIPPETS_ID,
      payload: {
        id
      }
    });
  }
};
